import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Popover from 'react-popover';

import * as S from './styled';

const Popup = ({
  children,
  preferPlace,
  place,
  trigger,
  isOpen,
  setPopupVisible,
  handleOuterAction,
  triggerWidth,
  appendTarget,
  zIndex,
}) => {
  const [isPopupOpen, setIsOpen] = useState(false);
  const isStateless = isOpen === null || isOpen === undefined;
  const shouldOpen = isStateless ? isPopupOpen : isOpen;

  return (
    <Popover
      body={<S.PopupBody>{children}</S.PopupBody>}
      style={{
        ...(zIndex
          ? {
              zIndex,
            }
          : {}),
      }}
      isOpen={shouldOpen}
      preferPlace={preferPlace}
      place={place}
      tipSize={0.01}
      onOuterAction={(ev) => {
        if (isStateless) {
          setIsOpen(false);
        } else {
          handleOuterAction(ev);
        }
      }}
      appendTarget={appendTarget || window.document.body}
    >
      <S.Trigger
        width={triggerWidth}
        onClick={() => {
          if (isStateless) {
            setIsOpen(true);
          } else {
            setPopupVisible();
          }
        }}
      >
        {trigger}
      </S.Trigger>
    </Popover>
  );
};

Popup.propTypes = {
  /**
   * Contents to render in popup
   */
  children: PropTypes.node,
  /**
   * Custom trigger
   */
  trigger: PropTypes.node,
  preferPlace: PropTypes.string,
  place: PropTypes.string,
  isOpen: PropTypes.bool,
  handleOuterAction: PropTypes.func,
  setPopupVisible: PropTypes.func,
};

Popup.defaultProps = {
  children: [],
  trigger: [],
  place: null,
  isOpen: null,
  triggerSize: 'medium',
  preferPlace: null,
  handleOuterAction: () => {},
  setPopupVisible: () => {},
};

export default Popup;
